import { Box, Button, Divider, Stack, Typography, useMediaQuery, useTheme } from '@mui/material';
import React, { useEffect, useState } from 'react';

import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import DiscountBanner from '../landingPage/discountBanner';
import FooterSection from '../footerSection';
import { Routes } from 'src/utils/enums';
import { ServiceType } from 'src/utils/types';
import backgroundImage from '../../resources/images/hero_img_bg.jpg';
import bannerBgImage from '../../resources/images/img_3.jpg';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';

interface SelectedServiceProps {
    service: ServiceType | null;
    onBackClick?: () => void;
}

const SelectedService: React.FC<SelectedServiceProps> = ({ service, onBackClick }) => {
    const [hovered, setHovered] = useState(false);
    const navigate = useNavigate();
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    useEffect(() => {
        window.scrollTo({ top: 0 });
    }, []);

    return (
        <Box sx={{ backgroundColor: '#fff' }}>
            <Stack
                direction="row"
                height="4.5rem"
                width="100%"
                alignItems="center"
                justifyContent="space-between"
                px={isMobile ? 2 : 4}
                boxShadow="0 4px 20px rgba(108, 96, 99, 0.3)"
                top={0}
                zIndex={99}
            >
                <Typography
                    fontSize={isMobile ? 18 : 24}
                    sx={{ cursor: 'pointer', fontWeight: 600 }}
                    onClick={() => navigate(Routes.LANDING_PAGE)}
                >
                    RealignHealthcare<span style={{ color: '#ea728c' }}>.</span>
                </Typography>

                {/* <Button
                    sx={{
                        backgroundColor: '#ea728c',
                        color: '#fff',
                        borderRadius: '30px',
                        px: '20px',
                        py: '10px',
                        textTransform: 'none',
                        '&:hover': { backgroundColor: '#d6607d' },
                    }}
                >
                    <Typography variant='button'>Book Now</Typography>
                </Button> */}
            </Stack>

            {service?.title && (
                <Box pt={4} p={isMobile ? 2 : 4} textAlign="center">
                    <Typography
                        variant="h3"
                        color="text.primary"
                        fontWeight={600}>{service.title}</Typography>
                </Box>
            )}

            <Box px={isMobile ? 2 : 10} display="flex" justifyContent="center">
                <Box
                    sx={{
                        position: 'relative',
                        width: '100%',
                        maxWidth: 1000,
                        height: isMobile ? 200 : 400,
                        borderRadius: '20px',
                        overflow: 'hidden',
                        boxShadow:
                            '0 10px 20px rgba(0,0,0,0.2)',
                    }}
                >
                    <img
                        src={backgroundImage}
                        alt={service?.title}
                        style={{
                            width: '100%',
                            height: '100%',
                            objectFit: 'cover',
                            objectPosition: 'top',
                            display: 'block',
                        }}
                    />
                    {/* <Button
                        variant="contained"
                        sx={{
                            position: 'absolute',
                            bottom: 16,
                            right: 16,
                            backgroundColor: '#f26e8d',
                            color: '#fff',
                            textTransform: 'none',
                            '&:hover': { backgroundColor: '#d85b7b' },
                        }}
                    >
                        Book This Service
                    </Button> */}
                </Box>
            </Box>

            <Stack px={isMobile ? 2 : 8} mb={8} spacing={6} alignItems="center" mt={8}>
                <Box px={2} width="100%" display="flex" justifyContent="center">
                    {service?.subTitle && (
                        <Typography
                            width="100%"
                            maxWidth={1000}
                            textAlign="center"
                            variant={isMobile ? 'h6' : 'h4'}
                            color="text.primary"
                            fontWeight={500}
                        >
                            {service?.subTitle}
                        </Typography>
                    )}
                </Box>

                <Divider sx={{ bgcolor: 'gray', width: '100%' }} />

                <Stack spacing={3} width="100%" maxWidth={1000}>
                    <Stack direction={{ md: 'row', xs: 'column' }} gap={4}>
                        {[service?.description.content1, service?.description.content2].map((content, index) => (
                            <Stack key={index} width={{ md: '50%', xs: '100%' }} spacing={1}>
                                <Typography variant="subtitle2" color="text.secondary">
                                    {content?.heading}
                                </Typography>
                                <Typography variant="body1" color="text.secondary">
                                    {content?.title}
                                </Typography>
                            </Stack>
                        ))}
                    </Stack>

                    <motion.div
                        animate={{ width: hovered ? 220 : 210 }}
                        transition={{ duration: 0.3, ease: 'easeInOut' }}
                        style={{ display: 'inline-block' }}
                    >
                        <Button
                            onClick={() => onBackClick || navigate(Routes.SERVICES_PAGE)}
                            onMouseEnter={() => setHovered(true)}
                            onMouseLeave={() => setHovered(false)}
                            sx={{
                                mt: 2,
                                backgroundColor: '#FFF',
                                border: 1,
                                borderColor: '#ea728c',
                                color: '#ea728c',
                                borderRadius: '30px',
                                px: '24px',
                                py: '12px',
                                textTransform: 'none',
                                display: 'flex',
                                alignItems: 'center',
                                gap: 1.5,
                                transition: 'border-color 0.3s, color 0.3s',
                                '&:hover': {
                                    borderColor: '#d6607d',
                                    color: '#d6607d',
                                },
                            }}
                        >
                            {hovered && (
                                <motion.div
                                    animate={{ opacity: 1, x: 0 }}
                                    initial={{ opacity: 0, x: -10 }}
                                    transition={{ type: 'spring', stiffness: 300, damping: 20 }}
                                    style={{ display: 'flex', alignItems: 'center' }}
                                >
                                    <ArrowBackIcon fontSize="small" />
                                </motion.div>
                            )}
                            <Typography variant="body1">Back to Services</Typography>
                        </Button>
                    </motion.div>
                </Stack>
            </Stack>
            {/** <Box mb={10} display="flex" justifyContent="center">
                <Box
                    sx={{
                        position: 'relative',
                        width: '100%',
                        maxWidth: 1000,
                        height: isMobile ? 200 : 400,
                        borderRadius: '20px',
                        overflow: 'hidden',
                        boxShadow: '0 10px 20px rgba(0,0,0,0.2)',
                    }}
                >
                    <img
                        src={backgroundImage}
                        alt={service?.title}
                        style={{
                            width: '100%',
                            height: '100%',
                            objectFit: 'cover',
                            objectPosition: 'top',
                            display: 'block',
                        }}
                    />

                    
                    <Box
                        sx={{
                            position: 'absolute',
                            bottom: 0,
                            left: 0,
                            width: '100%',
                            height: '100%',
                            background: 'linear-gradient(to top, #f26e8d, transparent)',
                            zIndex: 1,
                        }}
                    />

                    
                    <Box
                        sx={{
                            position: 'absolute',
                            bottom: 24,
                            left: 24,
                            zIndex: 2,
                            color: '#fff',
                            maxWidth: '70%',
                        }}
                    >
                        <Typography variant="h2_Thin" fontSize={isMobile ? '1.5rem' : '2rem'} fontWeight="bold" mb={1}>
                            Ready to get started?
                        </Typography>
                        <Typography fontSize={isMobile ? '0.875rem' : '1rem'} mb={2}>
                            Book your initial consultation today and take the first step towards a pain free, active life.
                        </Typography>
                        <Button
                            variant="contained"
                            sx={{
                                backgroundColor: '#fff',
                                color: '#f26e8d',
                                textTransform: 'none',
                                '&:hover': { backgroundColor: '#d85b7b', color: "#fff" },
                            }}
                        >
                            Find Out More
                        </Button>
                    </Box>
                </Box>
                 
            </Box>
            */}

            <Box
                sx={{
                    position: 'relative',
                    height: '60vh',
                    backgroundImage: `url(${bannerBgImage})`,
                    backgroundSize: 'cover',
                    backgroundAttachment: 'fixed',
                    backgroundPosition: 'center',
                    backgroundRepeat: 'no-repeat',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                }}
            >
                <Box
                    sx={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        backgroundColor: 'rgba(234, 114, 140, 0.9)',
                        zIndex: 1,
                    }}
                />
                <Box sx={{ position: 'relative', zIndex: 2 }}>
                    <DiscountBanner />
                </Box>
            </Box>

            <FooterSection />
        </Box>
    );
};

export default SelectedService;